<template>
  <div
    :class="{
      'layout-container': true,
      'layout-income': cssType == 1,
      'layout-default': cssType == 0,
    }"
  >
    <div class="top">
      <slot name="top"></slot>
    </div>
    <div class="middle">
      <slot></slot>
    </div>
    <div class="bottom">
      <slot name="bottom"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cssType: {
      default: 0,
      type: Number,
    },
  },
};
</script>

<style scoped lang="less">
.layout-container {
  box-sizing: border-box;
  background: #fff;
  padding: 50px 30px 30px 30px;

  .middle {
    margin: 15px 0;
    overflow: hidden;
  }
}

.layout-default {
  width: 100%;
}

.layout-income {
  background: transparent;
  width: 1300px;
  margin: 0 auto;
}
</style>
